export default {
  component: () => import('./page.vue'),
  path: '/model',
  name: 'model',
  meta: {
    title: '身份模型',
    auth: true,
  },
};
